/* eslint-disable react/no-unescaped-entities */
import { useRef } from 'react';
import { useTheme } from '@mui/material/styles';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
import {
	Grid,
	Card,
	CardContent,
	IconButton,
	useMediaQuery,
	Divider,
	Button,
	Typography,
	Box,
	List,
	Avatar,
	ImageList,
	ImageListItem,
	ListItem,
	ListItemText,
	ListItemAvatar,
	CardActions,
	ToggleButtonGroup,
	ToggleButton,
	Skeleton,
	TextField,
	Checkbox,
	CircularProgress,
	FormHelperText,
	FormHelperTextProps,
	FormGroup,
	FormControlLabel,
	FormControl,
	OutlinedInput,
	InputAdornment,
	LinearProgress,
	MenuItem,
} from '@mui/material';
import { ImageLoader } from '~/content/components/ImageLoader';

import clientMAINTAIN from '~/content/svg/clients/maintain_basis.webp';
// import quote from '~/content/images/noun-quote.png';

import { useTranslation } from 'react-i18next';

const References = (): JSX.Element => {
	const clientBayernRef = useRef(null);
	let { t } = useTranslation(['project_maintain-form']);
	const theme = useTheme();
	const { mode } = theme.palette;

	const isXs = useMediaQuery(theme.breakpoints.up('xs'), {
		defaultMatches: true,
	});
	const isSm = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});
	const isMd = useMediaQuery(theme.breakpoints.up('md'), {
		defaultMatches: true,
	});

	return (
		<Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
			<ImageLoader
				delay={true}
				intersectViewportCheck={true}
				childRef={clientBayernRef}
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}
			>
				<Box
					ref={clientBayernRef}
					component={'img'}
					height={1}
					width={1}
					src={clientMAINTAIN}
					alt='Logo von MAINTAIN Frankfurt'
					maxWidth={{ xs: 100, sm: 110, md: 120 }}
					marginBottom={3}
					sx={{
						filter: mode === 'dark' ? 'brightness(0) invert(1)' : 'none',
					}}
				/>
			</ImageLoader>
			<Box position={'relative'}>
				{/* <Box
					component={'img'}
					src={quote}
					sx={{
						position: 'absolute',
						width: 125,
						top: -35,
						right: -28,
						opacity: 0.12,
					}}
				/> */}

				<Box
					color={theme.palette.mode === 'light' ? '#D8D8D8' : '#53555C'}
					component={'svg'}
					xmlns='http://www.w3.org/2000/svg'
					viewBox='0 0 32 40'
					sx={{
						position: 'absolute',
						width: isSm ? 48 : 38,
						height: 'auto',
						top: isSm ? -50 : -40,
						right: -10,
						opacity: 1,
						overflow: 'hidden',

						userSelect: 'none',
						pointerEvents: 'none',
						fill: 'currentColor',
						stroke: 'currentColor',
					}}
				>
					<g transform='translate(-488 -626)'>
						<path
							data-name='Path 103'
							d='M515,1636l4-8h-6v-12h12v12l-4,8Zm-14,0,4-8h-6v-12h12v12l-4,8Z'
							transform='translate(-8 -984)'
							fillRule='evenodd'
						/>
					</g>
				</Box>

				{/* <Box
					component={'img'}
					src={quote}
					sx={{
						position: 'absolute',
						width: isSm ? 50 : 40,
						height: 'auto',
						top: isSm ? -45 : -35,
						right: -8,
						opacity: 0.12,
						overflow: 'hidden',
					}}
				/> */}
				<Typography
					color='text.secondary'
					variant='subtitle1'
					sx={{ fontSize: '1.05rem !important' }}
					component={'p'}
					align={'center'}
				>
					{t('references_text')}
				</Typography>
			</Box>
			<Box marginTop={{ xs: 2, sm: 4 }}>
				<Typography sx={{ fontWeight: 700 }} component={'h3'} variant='subtitle1' align={'center'}>
					{t('references_person')}
				</Typography>
				<Typography variant='subtitle1' component={'h4'} color='text.secondary' align={'center'}>
					{t('references_position')}
				</Typography>
			</Box>
		</Box>
	);
};

export default References;
